<div class="layout-row layout-align-start-center" *ngIf="checkTimeZoneOffsetDiff()">
  <bz-icon class="time-window-icon"
           [icon]="icons.timeZone"
           [ngbTooltip]="isTooltip ? timeZoneOffSetDiffTooltip : undefined"
           tooltipClass="bringoz-time-window-tooltip-popup"
           container="body"
           openDelay="300"
           triggers="hover">
  </bz-icon>
  <div *ngIf="!isTooltip" class="layout-row layout-align-start-center">
    <span class="br-body-2">{{ {notBefore: notBefore, notAfter: notAfter} | timeWindow: timeZoneId }} |</span>
    <span>{{ timeZoneId }} ({{ timeZoneOffsetDiff }}{{ 'hrs' | translate }})</span>
  </div>

  <ng-template #timeZoneOffSetDiffTooltip>
    <div class="layout-column">
      <span class="br-body-2 font-weight-600">{{ {notBefore: notBefore, notAfter: notAfter} | timeWindow: timeZoneId }}</span>
      <span class="br-caption time-window-tooltip-zone">{{ timeZoneId }} ({{ timeZoneOffsetDiff }} {{ 'hrs' | translate }})</span>
    </div>
  </ng-template>

</div>
